import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { CDR } from './components';

const routes = () => (
  <PrivateRoute exact path="/reporting/CDR" component={CDR} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/reporting/CDR/routes.js